/* @flow */

import "./ContentSearchResultHeader.scss";

import React from "react";

import { Clearfix } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import SearchTabs from "./SearchTabs";

type Props = {
    onTabClick: (tab: number) => void;
    activeTab: number;
};

class ContentSearchResultHeader extends React.Component<Props> {
    render() {
        return (
            <div>
                <Clearfix className="test-ex-content-search-header content-search-header mfcss_pageheader mfcss_pageheader-with-tabs">
                    <div className="mfcss_pageheader--headline">
                        <h3>
                            <FormattedMessage id="EX_CONTENT_SEARCH_HEADER" />
                        </h3>
                    </div>
                    <Clearfix />
                    <SearchTabs onTabClick={this.props.onTabClick} activeTab={this.props.activeTab} />
                </Clearfix>
            </div>
        );
    }
}

export default ContentSearchResultHeader;
